import { Link } from 'react-router';

type PlaceholderProps = {
  title: string;
};

/**
 * Page affichée quand l'adresse demandée n'existe pas.
 *
 * Elle doit rester accueillante : le visiteur s'est trompé d'adresse ou a suivi
 * un lien périmé, ce n'est pas une panne. On lui propose donc les deux chemins
 * les plus utiles plutôt que de le laisser dans une impasse.
 */
export function Placeholder({ title }: PlaceholderProps) {
  return (
    <section className="mx-auto max-w-3xl px-6 py-20 text-center">
      <p className="font-script text-4xl text-brand-pink mb-4">oups</p>
      <h1 className="text-3xl md:text-4xl mb-4">{title}</h1>
      <p className="text-brand-soft-ink">
        Cette page n’existe pas ou n’existe plus. Le lien a peut-être changé.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <Link
          to="/"
          className="rounded-full bg-brand-pink px-6 py-3 text-white transition-opacity hover:opacity-90"
        >
          Retour à l’accueil
        </Link>
        <Link to="/projects" className="text-brand-soft-ink underline underline-offset-4">
          Voir les réalisations
        </Link>
      </div>
    </section>
  );
}
